<template>
    <page
        showStepBackButton
        @step-back="stepBack"
        ref="page"
        :stepCount="stepCount"
        :step="formData.formstep"
        showMiniStepper
    >
        <transition name="fade" mode="out-in">
            <welcome
                :mode="formData.mode"
                :welcomeText="welcomeText"
                v-if="showWelcomeSection"
                @hide="showWelcomeSection = false"
            ></welcome>
            <stepper
                v-model="formData.formstep"
                hideProgress
                :count="stepCount"
                v-else
            >
                <stepper-item :step="stepMap.schadenArt">
                    <ereignis :mode="formData.mode" @change="changeFormData" />
                </stepper-item>
                <stepper-item
                    :step="stepMap.unfallbericht"
                    v-if="!isPrivatRechtsschutz"
                >
                    <unfallbericht
                        :isVisible="formData.formstep === stepMap.unfallbericht"
                        @change="changeFormData"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.unfallZeit">
                    <unfallzeit @change="changeFormData" />
                </stepper-item>
                <stepper-item :step="stepMap.unfallOrt">
                    <unfallort
                        :isVisible="formData.formstep === stepMap.unfallOrt"
                        @change="changeFormData"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.unfallBeschreibung">
                    <wert
                        title="Bitte beschreibe den Unfallhergang"
                        label="Was ist passiert?"
                        id="unfallBeschreibung"
                        @change="changeFormData"
                    />
                </stepper-item>
                <stepper-item
                    :step="stepMap.entstandenerschaden"
                    v-if="!isPrivatRechtsschutz"
                >
                    <schaden
                        :isVisible="
                            formData.formstep === stepMap.entstandenerschaden
                        "
                        @change="changeFormData"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.beteiligte">
                    <beteiligte
                        @change="changeFormData"
                        :mode="formData.mode"
                        title="Wer war am Unfall beteiligt?"
                        description="Gib alle am Unfall beteiligten Personen und deren Rolle
                        an"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.polizei">
                    <polizei-anzeige
                        @change="changeFormData"
                        :isVisible="formData.formstep === stepMap.polizei"
                        showStrafverfahren
                    />
                </stepper-item>
                <stepper-item
                    :step="stepMap.schadenHoehe"
                    v-if="isPrivatRechtsschutz"
                >
                    <schadenhoehe
                        title="Kannst du die Schadensansprüche abschätzen?"
                        hasSchadenhoeheId="hasSchadenhoehe"
                        schadenHoeheId="schadenHoehe"
                        kostenvoranschlagId="kostenvoranschlag"
                        @change="changeFormData"
                        :isVisible="formData.formstep === stepMap.schadenHoehe"
                    />
                </stepper-item>
                <stepper-item :step="stepMap.vertrag">
                    <!-- TODO: Logik für richtigen Vertrag (KFZ oder Wohnung/Haus) -->
                    <vertrag-auswahl
                        :feature="feature"
                        :additionalFeatures="additionalFeatures"
                        @change="changeFormData"
                        v-if="
                            $store.state.isLoggedIn &&
                            hasSchadensmeldungContract
                        "
                        :isVisible="formData.formstep === stepMap.vertrag"
                    />
                    <wert
                        title="Bitte gib hier deine Wüstenrot Rechtsschutz-Versicherungspolizze an"
                        label="Polizzennummer"
                        id="polizzenversicherung"
                        type="text"
                        @change="changeFormData"
                        v-else
                    />
                </stepper-item>
                <stepper-item :step="stepMap.person">
                    <person @change="changeFormData" />
                </stepper-item>
                <stepper-item :step="stepMap.zusammenfassung">
                    <zusammenfassung
                        :formData="formData"
                        @change-step="changeStep"
                        :stepMap="stepMap"
                    />
                    <div class="ion-text-center ion-margin-bottom">
                        <ion-button
                            class="-round -add-padding"
                            @click="submitForm"
                            >Schaden melden</ion-button
                        >
                    </div>
                </stepper-item>
            </stepper>
        </transition>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Welcome from "@/components/schadensmeldung/Welcome";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import Ereignis from "@/components/schadensmeldung/Ereignis";
import Unfallbericht from "@/components/schadensmeldung/Unfallbericht";
import Unfallzeit from "@/components/schadensmeldung/Unfallzeit";
import Unfallort from "@/components/schadensmeldung/Unfallort";
import Wert from "@/components/schadensmeldung/Wert";
import Schaden from "@/components/schadensmeldung/Schaden";
import Schadenhoehe from "@/components/schadensmeldung/Schadenhoehe";
import Beteiligte from "@/components/schadensmeldung/Beteiligte";
import PolizeiAnzeige from "@/components/schadensmeldung/PolizeiAnzeige";
import VertragAuswahl from "@/components/schadensmeldung/VertragAuswahl";
import Person from "@/components/schadensmeldung/Person";
import Zusammenfassung from "@/components/schadensmeldung/Zusammenfassung";
import { schadensmeldungNeu } from "@/mixins/schadensmeldungNeu";

export default {
    mixins: [schadensmeldungNeu],
    components: {
        Page,
        Welcome,
        Stepper,
        StepperItem,
        Ereignis,
        Unfallbericht,
        Unfallzeit,
        Unfallort,
        Wert,
        Schaden,
        Schadenhoehe,
        Beteiligte,
        PolizeiAnzeige,
        VertragAuswahl,
        Person,
        Zusammenfassung,
    },
    data() {
        return {
            feature: "SchadensmeldungRecht",
            additionalFeatures: [
                "SchadensmeldungRechtKfz",
                "SchadensmeldungRechtSach",
            ],
            formData: {
                mode: "recht",
                formstep: 1,
                schadenArt: "",
                hasUnfallbericht: "",
                unfallbericht: [],
                unfallDatum: "",
                unfallUhrzeit: "",
                unfallStrasse: "",
                unfallHausnr: "",
                unfallPlz: "",
                unfallOrt: "",
                unfallBeschreibung: "",
                entstandenerschaden: "",
                schadenBeschreibung: "",
                beteiligte: [],
                hasPolizeidokumente: "",
                strafverfahren: false,
                polizeiDokumente: [],
                hasSchadenhoehe: "",
                schadenHoehe: "",
                kostenvoranschlag: [],
                polizzenversicherung: "",
                geschlecht: "",
                vorname: "",
                zuname: "",
                geburtsdatum: "",
                email: "",
                telefon: "",
                // schadensfotos auf null, damit in zusammefassung ausgeblendet
                schadensfotos: null,
            },
        };
    },
    computed: {
        isPrivatRechtsschutz() {
            let result = false;
            if (this.formData.schadenArt === "Privat-Rechtsschutz") {
                result = true;
            }
            return result;
        },
        stepCount() {
            return 10 + !this.isPrivatRechtsschutz;
        },
        stepMap() {
            return {
                schadenArt: 1,
                unfallbericht: 2,
                unfallZeit: 2 + !this.isPrivatRechtsschutz,
                unfallOrt: 3 + !this.isPrivatRechtsschutz,
                unfallBeschreibung: 4 + !this.isPrivatRechtsschutz,
                entstandenerschaden: 5 + !this.isPrivatRechtsschutz,
                beteiligte:
                    5 + !this.isPrivatRechtsschutz + !this.isPrivatRechtsschutz,
                polizei:
                    6 + !this.isPrivatRechtsschutz + !this.isPrivatRechtsschutz,
                schadenHoehe:
                    7 + !this.isPrivatRechtsschutz + !this.isPrivatRechtsschutz,
                vertrag: 8 + !this.isPrivatRechtsschutz,
                person: 9 + !this.isPrivatRechtsschutz,
                zusammenfassung: 10 + !this.isPrivatRechtsschutz,
            };
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped></style>
